/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessRequestsAppAccessRule } from './AccessRequestsAppAccessRule';
import {
    AccessRequestsAppAccessRuleFromJSON,
    AccessRequestsAppAccessRuleFromJSONTyped,
    AccessRequestsAppAccessRuleToJSON,
} from './AccessRequestsAppAccessRule';

/**
 * 
 * @export
 * @interface GetAccessRequestsAppRulesMe200ResponseAllOf
 */
export interface GetAccessRequestsAppRulesMe200ResponseAllOf {
    /**
     * 
     * @type {Array<AccessRequestsAppAccessRule>}
     * @memberof GetAccessRequestsAppRulesMe200ResponseAllOf
     */
    result: Array<AccessRequestsAppAccessRule>;
}

/**
 * Check if a given object implements the GetAccessRequestsAppRulesMe200ResponseAllOf interface.
 */
export function instanceOfGetAccessRequestsAppRulesMe200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetAccessRequestsAppRulesMe200ResponseAllOfFromJSON(json: any): GetAccessRequestsAppRulesMe200ResponseAllOf {
    return GetAccessRequestsAppRulesMe200ResponseAllOfFromJSONTyped(json, false);
}

export function GetAccessRequestsAppRulesMe200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccessRequestsAppRulesMe200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(AccessRequestsAppAccessRuleFromJSON)),
    };
}

export function GetAccessRequestsAppRulesMe200ResponseAllOfToJSON(value?: GetAccessRequestsAppRulesMe200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(AccessRequestsAppAccessRuleToJSON)),
    };
}

